import styled from "styled-components"

export const TagsWrapper = styled.div`
  display: grid;
  align-items: flex-start;

  gap: 1rem;

  grid-template-columns: 1fr 1fr;

  span {
    display: flex;
    align-items: center;
  }

  svg {
    height: 2.6rem;
    margin-right: 1rem;
  }
`

export const MultiSelectWrapper = styled.div`
z-index: 3;
`
